import React from "react";
// reactstrap components
import {
    Button,
    Modal,
    Row,
    Col,
} from "reactstrap";
import './ConfirmModal.css'

function ConfirmModal(props) {
    
    let toggleModal = () => {
        props.setShowModal(!props.showModal)
    };

    let handleClick = () => {
        props.setModalResult(true)
        toggleModal()
    }

    // Verifica se é uma operação de binding e se há dados adicionais
    const isBindingOperation = props.modalOperation === 'bind';
    const hasBindingData = props.bindingData && props.appData;

    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={props.showModal}
                toggle={() => toggleModal()}
                backdrop="static" 
                keyboard={false}
            >
                <div className="modal-header bg-white">
                    <h3 className="modal-title" id="exampleModalLabel">
                        {props.title}
                    </h3>
                </div>

                <div className="modal-body">
                    {isBindingOperation && hasBindingData ? (
                        <>
                            <p className="mb-3">{props.message}</p>
                            
                            <div className="border rounded p-3 mb-3" style={{ backgroundColor: '#f8f9fa' }}>
                                <h5 className="mb-3">
                                    <i className="fas fa-user-graduate mr-2"></i>
                                    Student Information
                                </h5>
                                <Row className="mb-2">
                                    <Col xs="4" className="font-weight-bold">Name:</Col>
                                    <Col xs="8">{props.bindingData.name}</Col>
                                </Row>
                                {props.bindingData.institution && (
                                    <Row className="mb-2">
                                        <Col xs="4" className="font-weight-bold">Institution:</Col>
                                        <Col xs="8">{props.bindingData.institution}</Col>
                                    </Row>
                                )}
                            </div>

                            <div className="border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
                                <h5 className="mb-3">
                                    <i className="fas fa-mobile-alt mr-2"></i>
                                    Application
                                </h5>
                                <Row className="align-items-center">
                                    {props.appData.image && (
                                        <Col xs="3" className="text-center">
                                            <img 
                                                src={props.appData.image} 
                                                alt={props.appData.name}
                                                style={{ 
                                                    width: '50px', 
                                                    height: '50px',
                                                    borderRadius: '8px',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        </Col>
                                    )}
                                    <Col xs={props.appData.image ? "9" : "12"}>
                                        <div className="font-weight-bold" style={{ fontSize: '1.1rem' }}>
                                            {props.appData.name}
                                        </div>
                                        {props.appData.version && (
                                            <div className="text-muted small">
                                                Version: {props.appData.version}
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </div>

                            <div className="alert-message p-2 mt-3 mb-0 rounded text-white" >
                                <i className="fas fa-exclamation-triangle mr-2"></i>
                                <small>This action will consume one license from your account.</small>
                            </div>
                        </>
                    ) : (
                        <p>{props.message}</p>
                    )}
                </div>

                <div className="modal-footer">
                    <Button
                        className="btn-cancel"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => toggleModal()}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="btn-confirm"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => handleClick()}
                    >
                        Confirm
                    </Button>
                </div>                
            </Modal>
        </>
    );
}

export default ConfirmModal;